import { Controller } from "@hotwired/stimulus"
import Cropper from "cropperjs"
import "cropperjs/dist/cropper.css"

export default class extends Controller {
  static targets = [
    "dialog",
    "fileInput",
    "image",
    "preview",
    "previewContainer",
    "sourceInput",
  ]

  static values = {
    outputSize: { type: Number, default: 128 },
  }

  connect() {
    this.cropper = null
    this.objectUrl = null
  }

  disconnect() {
    this.destroyCropper()
    this.revokeObjectUrl()
  }

  pickSource(event) {
    event.preventDefault()
    this.sourceInputTarget.click()
  }

  sourceSelected() {
    const file = this.sourceInputTarget.files?.[0]
    this.sourceInputTarget.value = ""

    if (!file) return

    this.revokeObjectUrl()
    this.objectUrl = URL.createObjectURL(file)
    this.imageTarget.src = this.objectUrl
    this.imageTarget.removeAttribute("hidden")

    if (this.hasDialogTarget) {
      this.dialogTarget.showModal()
    }

    this.imageTarget.onload = () => {
      this.destroyCropper()
      this.cropper = new Cropper(this.imageTarget, {
        aspectRatio: 1,
        viewMode: 1,
        dragMode: "move",
        autoCropArea: 1,
        responsive: true,
        background: false,
      })
    }
  }

  applyCrop(event) {
    event.preventDefault()
    if (!this.cropper) return

    const canvas = this.cropper.getCroppedCanvas({
      width: this.outputSizeValue,
      height: this.outputSizeValue,
      imageSmoothingEnabled: true,
      imageSmoothingQuality: "high",
    })

    if (!canvas) return

    canvas.toBlob((blob) => {
      if (!blob) return

      const file = new File([blob], "logo.png", {
        type: "image/png",
        lastModified: Date.now(),
      })

      this.assignFile(file)
      this.updatePreview(canvas.toDataURL("image/png"))
      this.closeDialog()
    }, "image/png")
  }

  cancelCrop(event) {
    event.preventDefault()
    this.closeDialog()
  }

  dialogClosed() {
    if (this.cropper || this.objectUrl) {
      this.closeDialog()
    }
  }

  assignFile(file) {
    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.fileInputTarget.files = dataTransfer.files
    this.fileInputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  updatePreview(dataUrl) {
    if (!this.hasPreviewTarget) return

    this.previewTarget.src = dataUrl
    this.previewContainerTarget.classList.remove("hidden")
  }

  closeDialog() {
    this.destroyCropper()

    if (this.hasDialogTarget && this.dialogTarget.open) {
      this.dialogTarget.close()
    }

    this.imageTarget.setAttribute("hidden", "")
    this.imageTarget.removeAttribute("src")
    this.revokeObjectUrl()
  }

  destroyCropper() {
    if (!this.cropper) return

    this.cropper.destroy()
    this.cropper = null
  }

  revokeObjectUrl() {
    if (!this.objectUrl) return

    URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }
}
